import React, { useState } from "react";
import { useFilloutEmbed } from "../embed.js";
import { Loading } from "../components/Loading.js";
import { useMessageListener } from "../messages.js";
import { useFilloutEvents } from "../events.js";
export const Standard = ({ filloutId, domain, inheritParameters, parameters, dynamicResize, onInit, onPageChange, onSubmit, }) => {
    const [loading, setLoading] = useState(true);
    const embed = useFilloutEmbed({
        filloutId,
        domain,
        inheritParameters,
        parameters,
        dynamicResize,
    });
    useFilloutEvents(embed, { onInit, onPageChange, onSubmit });
    // dynamic resize
    const [height, setHeight] = useState();
    useMessageListener(embed, "form_resized", (data) => {
        const newHeight = data.size;
        if (typeof newHeight === "number") {
            setHeight(newHeight);
        }
    }, { disabled: !dynamicResize });
    return (React.createElement("div", { className: "fillout-standard-embed", style: {
            height: !dynamicResize
                ? "100%"
                : typeof height === "number"
                    ? height
                    : 256,
            transition: dynamicResize ? "height 150ms ease" : undefined,
        } },
        loading && (React.createElement("div", { style: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "100%",
                minHeight: 256,
            } },
            React.createElement(Loading, null))),
        embed && (React.createElement("iframe", { src: embed.iframeUrl, allow: "microphone; camera; geolocation", title: "Embedded Form", onLoad: () => setLoading(false), style: {
                width: !loading ? "100%" : 0,
                height: !loading ? "100%" : 0,
                opacity: !loading ? 1 : 0,
                borderRadius: 10,
                border: 0,
                minHeight: 256,
            } }))));
};
